import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { sendMessageToParentFrame } from '@/utils/sendMessageToParentFrame';

// These params are handled by the client
const QUERY_PARAMS_TO_OMIT = [
  'authHandledByParent',
  'instanceId',
  'error',
  'amworkspaceid',
  'expiry',
  'admin',
];

export function useParentRouteHandler() {
  // const { PARENT_FRAME_ORIGIN } = useConfig();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  // Sync react-router-dom with window
  useEffect(() => {
    navigate(
      {
        pathname: window.location.pathname,
        search: window.location.search,
      },
      { replace: true },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Notify parent of route changes
  useEffect(() => {
    if (window?.parent && window.parent !== window) {
      const params = new URLSearchParams(location.search);
      // Don't send authHandledByParent or instanceId to parent
      QUERY_PARAMS_TO_OMIT.forEach((param) => {
        params.delete(param);
      });

      sendMessageToParentFrame({
        route: location.pathname,
        search: params.toString(),
      });
    }
  }, [pathname, search]);

  // Handle parent route changes
  useEffect(() => {
    const handleParentMessage = (event: MessageEvent) => {
      // TODO: enable
      // if (!PARENT_FRAME_ORIGIN || event.origin !== PARENT_FRAME_ORIGIN) {
      //   console.error(`unable to verify  origin for message: ${event}`);
      //   return;
      // }

      const { route } = event.data;

      const currentRoute = window.location.pathname;
      if (route && route !== currentRoute) {
        navigate({ pathname: route }, { replace: false });
      }
    };

    window.addEventListener('message', handleParentMessage);
    return () => window.removeEventListener('message', handleParentMessage);
  }, [navigate]);
}
